export function Contents() {
  return <div className="bg-pink-100">Contents</div>;
}

export default Contents;
